export function getToken() {
	let token = window.localStorage.getItem("token");
	return token;
}

export function setToken(token) {
	window.localStorage.setItem("token", token);
}
export function removeToken() {
	window.localStorage.clear();
}

// 创建hash随机字符串
export function createHash (hashLength) {
　　// 默认长度 24
	let hashVal =  Array.from(Array(Number(hashLength) || 24), () => Math.floor(Math.random() * 36).toString(36)).join('');
	return hashVal.toUpperCase()
}
